// this file is intended to keep the bundle size down

export { Observable, Subject, fromEvent, ReplaySubject, Subscription, from, of } from 'rxjs';

export type { Observer } from 'rxjs';

import {
  buffer,
  bufferCount,
  bufferTime,
  debounce,
  debounceTime,
  filter,
  map,
  startWith,
  takeUntil,
  throttleTime,
} from 'rxjs/operators';

export const ops = {
  buffer,
  bufferCount,
  bufferTime,
  debounce,
  debounceTime,
  filter,
  map,
  startWith,
  takeUntil,
  throttleTime,
};
